import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PartnerDialogComponent } from '../partner-dialog/partner-dialog.component';

@Component({
  selector: 'app-skycard-partner',
  templateUrl: './skycard-partner.component.html',
  styleUrls: ['./skycard-partner.component.scss']
})
export class SkycardPartnerComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  openDialog(partner: any): void {
    this.dialog.open(PartnerDialogComponent, {
      width: '400px',
      data: partner  // ส่งข้อมูลของ partner ที่เลือก
    });
  }

  partners = [
    {
      name: 'Routine',
      image: '/assets/imgs/partner-01.jpg',
      description: 'ຮ້ານເສື້ອຜ້າ ຣູທີນ ສາຂາ ສີຫອມ (Routine Laos - Sihorm Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ສີຫອມ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 2222 1008. ຮ້ານເສື້ອຜ້າ ຣູທີນ ສາຂາ ຫຼວງພຣະບາງ (Routine Laos - Luangprabang Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ວຽງໄຊ, ນະຄອນຫຼວງພຣະບາງ, ແຂວງ ຫຼວງຣະບາງ, ໂທລະສັບ: +856 20 2222 1008. ຮ້ານເສື້ອຜ້າ ຣູທີນ ສາຂາ ຊຽງຂວາງ (Routine Laos - Xiengkhuang Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ໂພນສະຫວັນ, ເມືອງແປກ, ແຂວງ ຊຽງຂວາງ, ໂທລະສັບ: +856 20 2222 1008. ຮ້ານເສື້ອຜ້າ ຣູທີນ ສາຂາ ໄຊຍະບູລີ (Routine Laos - Sayabuly Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ສີເມືອງ, ເມືອງ ໄຊຍະບູລີ, ແຂວງ ໄຊຍະບູລີ, ໂທລະສັບ: +856 20 2222 1008',
      link :'https://www.facebook.com/share/5p6xCbNpzqkHprfc/?mibextid=LQQJ4d'
    },
    {
      name: 'A and T Minimart',
      image: '/assets/imgs/partner-02.jpg',
      description: 'ຮ້ານ ເອແອນທີ ມິນິມາກ ສ່ວນບຸກຄົນ (A and T Minimart), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ດົງປ່າລານທົ່ງ, ເມືອງ ສີສັດຕະນາກ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5571 5886',
      link :'https://www.facebook.com/share/15zU4x8W52/?mibextid=wwXIfr'
    },
    {
      name: 'Chansomphou Silk individual',
      image: '/assets/imgs/partner-03.jpg',
      description: 'ຮ້ານ ຈັນຊົມພູ ຜ້າໃໝ ສ່ວນບຸກຄົນ (Chansomphou Silk individual), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ໂພໄຊ, ເມືອງ ສີສັດຕະນາກ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 5444 7180',
      link :'https://www.facebook.com/share/19CpLGS8tM/?mibextid=wwXIfr'
    },
    {
      name: 'Winsun Wine - Liquar Shop Individual',
      image: '/assets/imgs/partner-04.jpg',
      description: 'ຮ້ານເຫຼົ້າ-ວາຍ ວິນສັນ  (Winsun Wine - Liquar Shop Individual), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ດອນແດງ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5566 9488',
      link :'https://www.facebook.com/fabulouswinelaos?mibextid=ZbWKwL'
    },
    {
      name: 'Vanniyom Wine & Liquors store – Hongkha Branch',
      image: '/assets/imgs/partner-05.jpg',
      description: 'ຮ້ານ ເຫຼົ້າວາຍ ວັນນິຍົມ ສາຂາຮ່ອງຄ້າ  (Vanniyom Wine & Liquors store – Hongkha Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ຮ້ອງຄ້າ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 2223 7223. ຮ້ານ ເຫຼົ້າວາຍ ວັນນິຍົມ ສາຂາໂພນພະເນົາ  (Vanniyom Wine & Liquors store – Phonphanao Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ໂພນພະເນົາ, ເມືອງ ໄຊເສດຖາ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 2223 7223. ຮ້ານ ເຫຼົ້າວາຍ ວັນນິຍົມ ສາຂາທ່າພະລານໄຊ (Vanniyom Wine & Liquors store – Thaphalanxay Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ທ່າພະລານໄຊ, ເມືອງ ສີສັດຕະນາກ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 2223 7223. ຮ້ານ ເຫຼົ້າວາຍ ວັນນິຍົມ ສາຂາຊ້າງຄູ້ (Vanniyom Wine & Liquors store – Xangkhou Branch), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ຊ້າງຄູ້, ເມືອງ ໄຊທານີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 2223 7223.',
      link :'https://www.facebook.com/share/19rgf6t1Js/?mibextid=wwXIfr'
    },
    {
      name: 'Souliyaseng Restaurant',
      image: '/assets/imgs/partner-06.jpg',
      description: 'ຮ້ານອາຫານ ສຸລິຍະແສງ (Souliyaseng Restaurant), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ດອນແດງ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5566 9488',
      link :'https://www.facebook.com/share/p/fR6vVqo1dmHiC78x/?mibextid=qi2Omg'
    },
    {
      name: 'Light House Vientiane',
      image: '/assets/imgs/partner-07.jpg',
      description: 'ຮ້ານອາຫານ ໄລ້ເຮົ້າ ວຽງຈັນ (Light House Vientiane), ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນ ສຸພານຸວົງ, ບ້ານ ວັດໄຕໃຫຍ່, ເມືອງ ສີໂຄດຕະບອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 2881 1277',
      link :'https://www.facebook.com/share/1Fj5TyXbYe/?mibextid=wwXIfr'
    },
    {
      name: 'Common Ground Café',
      image: '/assets/imgs/partner-08.jpg',
      description: 'ຄອມມ້ອນ ກຮາວ ຄາເຟ້ (Common Ground Café), ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນ ເຈົ້າອານຸ, ບ້ານ ວັດຈັນ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 30 444 3028 / +856 20 9966 7615',
      link :'https://www.facebook.com/share/1APzSSuHAf/?mibextid=wwXIfr'
    },
    {
      name: 'Simple Day Cafe',
      image: '/assets/imgs/partner-09.jpg',
      description: 'ຮ້ານ ຊິມເປ້ວ ເດ ຄາເຟ້ (Simple Day Cafe), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ດົງຄຳຊ້າງ, ເມືອງ ຫາດຊາຍຟອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5713 6699',
      link :'https://www.facebook.com/share/192AbVJaoM/?mibextid=wwXIfr'
    },
    {
      name: 'Sailomyen Café & Hostel',
      image: '/assets/imgs/partner-10.jpg',
      description: 'ສາຍລົມເຢັນ ຄາເຟ້ (Sailomyen Café & Hostel), ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນສາຍລົມ, ບ້ານ ສາຍລົມ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 9963 6363 / +856 209575 9955',
      link :'https://www.facebook.com/share/BdDCdZvTokRTobb6/?mibextid=LQQJ4d'
    },
    {
      name: 'Benoni Cafe',
      image: '/assets/imgs/partner-11.jpg',
      description: 'ຮ້ານ ເບໂນນີ້ ຄາເຟ້ (Benoni Cafe), ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນ ສາມແສນໄທ, ບ້ານ ຊຽງຍືນ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 21 253 228 / +856 20 7878 7809',
      link :'https://www.facebook.com/share/N2gngNDMBdyM2QMb/?mibextid=LQQJ4d'
    },
    {
      name: 'Tree town cafe',
      image: '/assets/imgs/partner-12.jpg',
      description: 'ຮ້ານ ທຣີທາວ ຄາເຟ້ (Tree town cafe), ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນ ເຈົ້າອານຸວົງ, ບ້ານ ວັດຈັນ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5465 5456',
      link :'https://www.facebook.com/TreeTownCafeVientiane?mibextid=LQQJ4d'
    },
    {
      name: 'Walkman Village – Watchan',
      image: '/assets/imgs/partner-13.jpg',
      description: 'ຮ້ານເສື້ອຜ້າ ວ໊ອກແມນ ວິນເລດ ສາຂາ ວັດຈັນ  (Walkman Village – Watchan), ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນ ເຈົ້າຟ້າງຸ່ມ, ບ້ານ ວັດຈັນ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5550 2966ຮ້ານເສື້ອຜ້າ ວ໊ອກແມນ ວິນເລດ ສາຂາ ສີຫອມ  (Walkman Village – Sihorm), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ອານຸ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5550 2966',
      link :'https://www.facebook.com/share/p/WYVBipH9bDDw6N8Y/?mibextid=WC7FNe'
    },
    {
      name: 'Muk coffee individual enterprise',
      image: '/assets/imgs/partner-14.jpg',
      description: 'ວິສາຫະກິດ ສ່ວນບຸກຄົນ ມັກກາເຟ ສາຂາ 1 (Muk coffee individual enterprise), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ໂພນສະຫວ່າງ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 2804 8696. ວິສາຫະກິດ ສ່ວນບຸກຄົນ ມັກກາເຟ ສາຂາ 2 (Muk coffee individual enterprise), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ທົ່ງຂັນຄຳ, ເມືອງ ຈັນທະບູລີ, ນະຄອນຫລວງວຽງຈັນ. ໂທລະສັບ: +856 20 5210 7079. ວິສາຫະກິດ ສ່ວນບຸກຄົນ ມັກກາເຟ ສາຂາ 3 (Muk coffee individual enterprise), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ສະພານທອງ, ເມືອງ ສີສັດຕະນາກ, ນະຄອນຫລວງວຽງຈັນ. ໂທລະສັບ: +856 20 5454 4257. ວິສາຫະກິດ ສ່ວນບຸກຄົນ ມັກກາເຟ ສາຂາ 4 (Muk coffee individual enterprise), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ດົງໂດກ, ເມືອງ ໄຊທານີ, ນະຄອນຫລວງວຽງຈັນ. ໂທລະສັບ: +856 20 5266 6156. ວິສາຫະກິດ ສ່ວນບຸກຄົນ ມັກກາເຟ ສາຂາ 5 (Muk coffee individual enterprise), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ສົມຫວັງ, ເມືອງ ຫາດຊາຍຟອງ, ນະຄອນຫລວງວຽງຈັນ. ໂທລະສັບ: +856 20 5964 5193.',
      link :'https://www.facebook.com/share/1CRD2aoWzk/?mibextid=wwXIfr'
    },
    {
      name: 'Individual Enterprise Jou Khaohom Store',
      image: '/assets/imgs/partner-15.jpg',
      description: 'ຮ້ານ ຈູ່ເຂົ້າຫອມ (Individual Enterprise Jou Khaohom Store), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ນາໄຫ, ເມືອງ ຫາດຊາຍຟອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5522 1919',
      link :'https://www.facebook.com/share/18UJTFvPS9/?mibextid=wwXIfr'
    },
    {
      name: 'Hubxub Restaurant Individual Enterprise',
      image: '/assets/imgs/partner-16.jpg',
      description: 'ຮ້ານ ອາຫານ ຮັບຊັບ ສ່ວນບຸກຄົນ (Hubxub Restaurant Individual Enterprise), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ນາໄຫ, ເມືອງ ຫາດຊາຍຟອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5522 1919',
      link :'https://www.facebook.com/share/1JY97pQD2i/?mibextid=wwXIfr'
    },
    {
      name: 'Purple Bear',
      image: '/assets/imgs/partner-17.png',
      description: 'ຮາ້ນ ອາຫານໝີມ້ວງ, ສະຖານທີີ່ຕັັ້ງຢູ່ ຖະໜົນ ເລກທີີ່ 13ເໜືອ, ບ້ານ ດົງຫຼວງ, ເມືອງນາຊາຍທອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 56829568',
      link :'https://www.facebook.com/share/1AAa6jfAss/?mibextid=wwXIfr'
    },
    {
      name: 'MiNNie Beauty & Spa',
      image: '/assets/imgs/partner-18.jpg',
      description: 'MiNNie Beauty & Spa, ສະຖານທີ່ຕັ້ງຢູ່ ຖະໜົນໄກສອນ, ບ້ານໄຊສະຫວ່າງ, ເມືອງໄຊທານີ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +85620 56889294',
      link :'https://www.facebook.com/share/1HZCrVuewK/?mibextid=wwXIfr'
    },
    {
      name: 'Laffe Individual Enterprise',
      image: '/assets/imgs/partner-19.jpg',
      description: 'Laffe Individual Enterprise, ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ເມືອງວາທົ່ງ, ເມືອງ ສີໂຄດຕະບອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5469 1552',
      link :'#'
    },
    {
      name: 'Thin Thaan Home Coffee Roastery and Café Individual',
      image: '/assets/imgs/partner-20.png',
      description: 'ວິສາຫະກິດສ່ວນບຸກຄົນ ຮ້ານຖິ່ນຖານບ້ານກາເຟ ແລະ ຫ້ອງຂົ້ວກາເຟ (Thin Thaan Home Coffee Roastery and Café Individual), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ສີໄຄທົ່ງ, ເມືອງ ສີໂຄດຕະບອງ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 5988 8328',
      link :'https://www.facebook.com/share/18qvYUYvPK/?mibextid=wwXIfr'
    },
    {
      name: 'Complete Dental Care Center Sole Co.,Ltd',
      image: '/assets/imgs/partner-21.jpg',
      description: 'ບໍລິສັດ ສູນທັນຕະກຳປິ່ນປົວແຂ້ວຄົບວົງຈອນ ຈຳກັດຜູ້ດຽວ (Complete Dental Care Center Sole Co.,Ltd), ສະຖານທີ່ຕັ້ງຢູ່ ບ້ານ ເພຍວັດ, ເມືອງ ສີສັດຕະນາກ, ນະຄອນຫຼວງວຽງຈັນ, ໂທລະສັບ: +856 20 9869 4959',
      link :'https://www.facebook.com/share/15Uk3HUTjk/?mibextid=wwXIfr'
    },
  ];


  ngOnInit(): void {
  }

}
